import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';
// import { trapFocus, removeTrapFocus } from '@theme/focus';

// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  // get floatingPanelComponent() {
  //   const floatingPanelComponent = this.details.querySelector('floating-panel-component');

  //   if (!(floatingPanelComponent instanceof HTMLElement)) return;

  //   return floatingPanelComponent;

  // }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
    // this.floatingPanelComponent?.addEventListener('click', this.selectOption, { signal })
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    // Stop default behaviour from the browser
    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
  };

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      // removeTrapFocus();
      this.summary.focus();
    }
  }
    // } else {
    //     if(this.floatingPanelComponent) trapFocus(this.floatingPanelComponent);   
    // }


//     /**
//    * @param {Event} event - The select event
//    */
// selectOption = (event) => {

//   event.preventDefault();
//   if (!(event.target instanceof HTMLElement)) {
//     throw new Error('Event target is not an HTMLElement');
//   }

//   let input = event.target.querySelector('input');

//   if (!input) return;

//   const panelInputs = this.floatingPanelComponent?.querySelectorAll('input');
//   if(panelInputs) {
//     panelInputs.forEach((el) => {
//       el.checked = false;
//       el.removeAttribute('checked')
//     });
    
//     input.checked = true;
//     input.setAttribute('checked','');
//     input.dispatchEvent(new Event('change', { bubbles: true }));
//     removeTrapFocus();
//     this.summary.focus();
  
//     // console.log('option selected!')
//   }

// }


}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}
